// extracted by mini-css-extract-plugin
export default {"wrapper":"GY-z","message":"HY-z","image":"IY-z"};